import React, { useEffect } from 'react';
import { Route, Routes, Navigate, useLocation, matchPath, useNavigate } from 'react-router-dom';
import Login from '../pages/Login/Login';
import Loginselect from '../pages/Login/Loginselect';
import Homepage from '../pages/homepage/Homepage';
import RegisterDetail1 from '../pages/Login/RegisterDetail1';
import RegisterDetail2 from '../pages/Login/RegisterDetail2';
import RegisterDetail3 from '../pages/Login/RegisterDetail3';
import RegisterDetail4 from '../pages/Login/RegisterDetail4';
import TermsandCondition from '../pages/Terms/TermsandCondition';
import UserJobSeekers from '../pages/admin/UserJobSeekers';
import Dashboard from '../pages/user/Dashboard';
import ForgetPassword from '../pages/Login/ForgetPassword';
import ResetPassword from '../pages/Login/ResetPassword';
import { useState } from 'react';
import UserGroup from '../pages/admin/UserGroup';
import UserGroupEdit from '../pages/admin/UserGroupEdit';
import UserMember from '../pages/admin/UserMember';
import UserGroupAdd from '../pages/admin/UserGroupAdd';
import UserMemberAdd from '../pages/admin/UserMemberAdd';
import UserMemberEdit from '../pages/admin/UserMemberEdit';
import JobseekerProfile from '../pages/admin/JobseekerProfile';
import RegisterIds from '../pages/Login/RegisterIds';
import KnowledgeArticle from '../pages/Knowledge/KnowledgeArticle';
import KnowledgeArticleView from '../pages/Knowledge/KnowledgeArticleView';
import KnowledgeBase from '../pages/Knowledge/KnowledgeBase';
import KnowledgeCategory from '../pages/Knowledge/KnowledgeCategory';
import KnowledgeSubCategory from '../pages/Knowledge/KnowledgeSubCategory';
import Draft from '../pages/Knowledge/Draft';
import DraftAdd from '../pages/Knowledge/DraftAdd';
import KnowledgeArticlePreview from '../pages/Knowledge/KnowledgeArticlePreview';
import DraftEdit from '../pages/Knowledge/DraftEdit';
import UnderApproval from '../pages/Knowledge/UnderApproval';
import UnderApprovalShow from '../pages/Knowledge/UnderApprovalShow';
import UnderApprovalHistory from '../pages/Knowledge/UnderApprovalHistory';
import Published from '../pages/Knowledge/Published';
import Retired from '../pages/Knowledge/Retired';
import Allheader from '../components/common/Allheader';
import Catalogs from '../pages/Jobseekers/Catalog/Catalogs';
import EditRequest from '../pages/Jobseekers/Catalog/EditRequest';
import MarketHold from '../pages/Jobseekers/Catalog/MarketHold';
import Certifications from '../pages/Jobseekers/Catalog/Certifications';
import ReportTechIssue from '../pages/Jobseekers/Catalog/ReportTechIssue';
import Feedback from '../pages/Jobseekers/Catalog/Feedback';
import Attachments from '../pages/Knowledge/Attachments';
import Discursion from '../pages/Knowledge/Discursion';
import Notifications from '../components/common/Notifications';
import VersionsArticle from '../pages/Knowledge/VersionsArticle';
import MyRequest from '../pages/Jobseekers/Tasks/MyRequest';
import MyTask from '../pages/Jobseekers/Tasks/MyTask';
import ProfileCorrection from '../pages/Jobseekers/Tasks/ProfileCorrection';
import I94Validation from '../pages/Jobseekers/Tasks/I94Validation/I94Validation';
import VerifyMember from '../pages/Jobseekers/Tasks/VerifyMember/VerifyMember';
import MemberConfirmation from '../pages/Jobseekers/Tasks/VerifyMember/MemberConfirmation';
import ReferralInvestigation from '../pages/Jobseekers/Tasks/VerifyMember/ReferralInvestigation';
import JobseekersClassification from '../pages/Jobseekers/Tasks/JobseekersClassification/JobseekersClassification';
import EngagementOverview from '../pages/Jobseekers/Tasks/EngagementOverview/EngagementOverview';
import SetupInterview from '../pages/Jobseekers/Tasks/SetupInterview/SetupInterview';
import InterviewEvaluation from '../pages/Jobseekers/Tasks/SetupInterview/InterviewEvaluation';
import TermsofServices from '../pages/Terms/TermsofServices';
import PrivacyPolicy from '../pages/Terms/PrivacyPolicy';
import ApplicationFinalReview from '../pages/Jobseekers/Tasks/ApplicationFinalReview/ApplicationFinalReview';
import CommunicationEligibility from '../pages/Jobseekers/Tasks/CommunicationEligibility/CommunicationEligibility';
import PastPaymentHealth from '../pages/Jobseekers/Tasks/PastPaymentHealth/PastPaymentHealth';
import AdmissionFeesPayment from '../pages/Jobseekers/Tasks/PastPaymentHealth/AdmissionFeesPayment';
import ImmigrationHistory from '../pages/Jobseekers/Tasks/ImmigrationHistory/ImmigrationHistory';
import ImmigrationReview from '../pages/Jobseekers/Tasks/ImmigrationHistory/ImmigrationReview';
import JobPostLinkedin from '../pages/Jobseekers/Tasks/PublishJobPost/JobPostLinkedin';
import ApplyforJob from '../pages/Jobseekers/Tasks/PublishJobPost/ApplyforJob';
import GroupTask from '../pages/Jobseekers/Tasks/GroupTask';
import PlacementAgreements from '../pages/Jobseekers/Tasks/ApplicationFinalReview/PlacementAgreements';
import ValidateCats from '../components/common/ValidateCats';
import AllTaskList from '../pages/Jobseekers/Tasks/AllTaskList';
import MyCases from '../pages/Jobseekers/Tasks/MyCases';
import TechReportView from '../pages/Jobseekers/Tasks/TechReportView';
import JobseekerFormDetails from '../pages/admin/JobseekerFormDetails';
import CommunityMember from '../pages/Communitymember/CommunityMember';
import CommunityMemberAdd from '../pages/Communitymember/CommunityMemberAdd';
import SettingsGeneral from '../pages/Settings/SettingsGeneral';
import SettingsOnboard from '../pages/Settings/SettingsOnboard';
import SettingsSmtp from '../pages/Settings/SettingsSmtp';
import SettingsS3file from '../pages/Settings/SettingsS3file';
import SettingsPayment from '../pages/Settings/SettingsPayment';
import SettingsSocialLink from '../pages/Settings/SettingsSocialLink';
import ViewCommunityMember from '../pages/Communitymember/ViewCommunityMember';
import JobBoard from '../pages/jobboard/JobBoard';
import AddJobBoard from '../pages/jobboard/AddJobBoard';
import CommunityMemberEdit from '../pages/Communitymember/CommunityMemberEdit';
import ViewJobBoard from '../pages/jobboard/ViewJobBoard';
import MyJobs from '../pages/jobboard/MyJobs';
import ViewJobDetails from '../pages/jobboard/ViewJobDetails';
import JobList from '../pages/jobboard/JobList';
import KbAssignments from '../pages/Knowledge/KbAssignments';
import { apiService } from '../services/apiService';
import JobseekerFormEdit from '../pages/admin/JobseekerFormEdit';
import SeekerProfile from '../pages/Profiles/SeekerProfile';
import MemberProfile from '../pages/Profiles/MemberProfile';
import ReportBtex from '../pages/Jobseekers/Catalog/ReportBtex';
import KnowledgeArticleBookmark from '../pages/Knowledge/KnowledgeArticleBookmark';
import JobBulkUpload from '../pages/jobboard/JobBulkUpload';
import RecruiterReviews from '../pages/RecruiterReviews/RecruiterReviews';
import ViewRecruiterReview from '../pages/RecruiterReviews/ViewRecruiterReview';
import EditJobs from '../pages/jobboard/EditJobs';
import OrgChart from '../pages/OrgChart/OrgChart';
import SubmitTimesheet from '../pages/Timesheet/SubmitTimesheet';
import ActivityTimesheet from '../pages/Timesheet/ActivityTimesheet';
import ManageTimesheet from '../pages/Timesheet/SubadminTimesheet/ManageTimesheet';
import ApproveTimesheet from '../pages/Timesheet/SubadminTimesheet/ApproveTimesheet';
import NotesTimesheet from '../pages/Timesheet/SubadminTimesheet/NotesTimesheet';
import FilesTimesheet from '../pages/Timesheet/SubadminTimesheet/FilesTimesheet';
import AccepetedTermsServices from '../pages/Terms/AccepetedTermsServices';
import SettingsTerms from '../pages/Settings/SettingsTerms';
import ManageProjectTimesheet from '../pages/Timesheet/SubadminTimesheet/projects/ManageProjectTimesheet';
import ApproveProjectTimesheet from '../pages/Timesheet/SubadminTimesheet/projects/ApproveProjectTimesheet';
import TimesheetAdmin from '../pages/Timesheet/SubadminTimesheet/TimesheetAdmin';
import TimesheetProject from '../pages/Timesheet/SubadminTimesheet/TimesheetProject';
import Reports from '../pages/Reports/Reports';
import ReportsJobseeker from '../pages/Reports/ReportsJobseeker';
import MyDashboard from '../pages/Reports/MyDashboard';
import ReportsKba from '../pages/Reports/ReportsKba';
import SessionActive from '../components/SessionActive';
import UserRoles from '../pages/admin/UserRoles';
import UserRoleDetail from '../pages/admin/UserRoleDetail';
import UserAuditHistory from '../pages/admin/UserAuditHistory';
import KnowledgeViewLogout from '../pages/Knowledge/KnowledgeViewLogout';
import GeneralCase from '../pages/Jobseekers/Catalog/GenaralCase/GeneralCase';
import Triage from '../pages/Jobseekers/Catalog/GenaralCase/Triage';
import GlobalService from '../pages/Jobseekers/Catalog/GlobalService';
import InProgress from '../pages/Jobseekers/Catalog/GenaralCase/InProgress';
import PartnerStep from '../pages/Jobseekers/Catalog/GenaralCase/PartnerStep';
import SeniorPartStep from '../pages/Jobseekers/Catalog/GenaralCase/SeniorPartStep';
import Solutions from '../pages/CaseManagement/Solutions';
import CaseType from '../pages/CaseManagement/CaseType';
import CaseSubType from '../pages/CaseManagement/CaseSubType';
import IntakeForm from '../pages/Jobseekers/Catalog/GenaralCase/IntakeForm';
import ConsultingServices from '../pages/Jobseekers/Catalog/ConsultingServices';
import InterviewsBooking from '../pages/Jobseekers/Catalog/InterviewModule/InterviewsBooking';
import InterviewsSlot from '../pages/Jobseekers/Catalog/InterviewModule/InterviewsSlot';
import CreateOpportunity from '../pages/Jobseekers/Catalog/InterviewModule/CreateOpportunity';
import Opportunity from '../pages/Jobseekers/Catalog/InterviewModule/Opportunity';
import CreateInterview from '../pages/Jobseekers/Catalog/InterviewModule/CreateInterview';
import InterviewIntake from '../pages/Jobseekers/Catalog/InterviewModule/InterviewTask/InterviewIntake';
import MyRaisedCases from '../pages/Jobseekers/Tasks/MyRaisedCases';
import MyGroupCases from '../pages/Jobseekers/Tasks/MyGroupCases';
import RaisedCasesSeekers from '../pages/Jobseekers/Tasks/RaisedCasesSeekers';
import ItRecruiterMain from '../pages/Recruiter/ItRecruiter/ItRecruiterMain';
import ItRecruiterCreate from '../pages/Recruiter/ItRecruiter/ItRecruiterCreate';
import ItRecruiterEdit from '../pages/Recruiter/ItRecruiter/ItRecruiterEdit';
import ItRecruiterShow from '../pages/Recruiter/ItRecruiter/ItRecruiterShow';
import VendorCompanyMain from '../pages/Recruiter/VendorCompany/VendorCompanyMain';
import VendorCompanyShow from '../pages/Recruiter/VendorCompany/VendorCompanyShow';
import VendorCompanyCreate from '../pages/Recruiter/VendorCompany/VendorCompanyCreate';
import VendorCompanyEdit from '../pages/Recruiter/VendorCompany/VendorCompanyEdit';
import RecruiterForm from '../pages/Jobseekers/Catalog/InterviewModule/InterviewTask/RecruiterForm';

const AppRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const isMdScreen = window.matchMedia('(max-width: 991px)').matches;
    const [formData, setFormData] = useState({});
    const [role, setRole] = useState(localStorage.getItem('role'));
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [isLoading, setIsLoading] = useState(true);
    const handleFormDataChange = (stepData) => {
        setFormData(prevData => ({ ...prevData, ...stepData }));
    };

    const [loggedIn, setLoggedIn] = useState(false);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token === "undefined") {
            setLoggedIn(false);
        } else if (token) {
            setLoggedIn(true);
        } else {
            setLoggedIn(false);
        }
    }, [navigate]);

    useEffect(() => {
        const hasCheckedAuth = sessionStorage.getItem('authCheckedOnce');

        if (hasCheckedAuth === 'true') {
            setIsLoading(false); // Allow rendering immediately
            return;
        }

        const fetchData = async () => {
            try {
                const response = await apiService.postRequest(`profile`);

                if (response.success) {
                    sessionStorage.setItem('authCheckedOnce', 'true');
                } else {
                    sessionStorage.setItem('authCheckedOnce', 'true');
                    if (response && response.authenticate === false) {
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                    }
                    if (currentPath !== "/" && currentPath !== "/loginselect" && currentPath !== "/privacypolicy" && currentPath !== "/termsofservice" && !(loggedIn !== true && matchPath('/knowledge-article/:slug', currentPath))) {
                        navigate("/login");
                    }
                }
            } catch (error) {
                console.error('Error', error);
            } finally {
                setIsLoading(false); // Stop loading regardless
            }
        };

        fetchData();
    }, [navigate, currentPath, loggedIn]);


    const headerVisiblePaths = ['/', '/login', ...(loggedIn !== true ? ['/knowledge-article/:slug'] : []), '/loginselect', '/forgotpassword', '/resetpassword', '/termsandcondition', '/termsofservice', '/accepted-terms-conditions/:userid', '/privacypolicy', '/registration', '/registration/personal-questions', '/registration/immigration-questions', '/registration/emergency-contact', '/registration/referral-information'];
    // const hideHeader = headerVisiblePaths.some((path) => matchPath({ path, end: true }, location.pathname));

    const hideHeader = headerVisiblePaths.some((path) =>
        matchPath(path, location.pathname)
    );

    useEffect(() => {
        const handleStorageChange = () => {
            setRole(localStorage.getItem('role'));
        };

        // Add event listener to detect localStorage changes
        window.addEventListener('storage', handleStorageChange);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    function OnboardSiders() {
        const location = useLocation();

        // Define the paths where the component should be visible
        const allowedPaths = [
            "/task/i94-validation/:userid/:taskid",
            "/task/verify-member-details/:userid/:taskid",
            "/task/member-confirmation/:userid/:taskid",
            "/task/referral-investigation/:userid/:taskid",
            "/task/engagement-overview/:userid/:taskid",
            "/task/jobseeker-classification/:userid/:taskid",
            "/task/setup-servicenow-interview/:userid/:taskid",
            "/task/servicenow-interview-evaluation/:userid/:taskid",
            "/task/past-payment-health-approval/:userid/:taskid",
            "/task/application-final-review/:userid/:taskid",
            "/task/placement-agreement/:userid/:taskid",
            "/task/communication-eligibility/:userid/:taskid",
            "/task/admission-fees-payment/:userid/:taskid",
            "/task/my_request_profile/:userid/:taskid",
        ];

        // Check if the current path is in the allowedPaths array
        const isVisible = allowedPaths.some((path) => matchPath({ path, end: true }, location.pathname));

        const [isVisiblemob, setIsVisible] = useState(true);
        const closeElement = () => {
            setIsVisible(true);
        };
        return (
            <>
                {isVisible && (
                    <div className={isVisiblemob ? 'hide_mobitr' : 'show_mobitr'}>
                        <ValidateCats onClose={closeElement} />
                    </div>
                )}
            </>
        );
    }

    if (isLoading && currentPath !== "/") {
        return <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "100vh" }}>{currentPath !== "/" && <img src={require("../assets/pinkloader.gif")} alt="" />}</div>; // or your custom spinner
    }
    const handleClose = () => console.log("ValidateCats closed");
    const AuthenticatedRoutes = () => (
        <>
            <OnboardSiders />
            <Routes>
                {isMdScreen ?
                    <>
                        <Route path="/knowledge" element={<KnowledgeArticle />} />
                        {loggedIn === true && permissionstest?.manage_knowledge_article === true ?
                            <Route path="/knowledge-article/:slug" element={<KnowledgeArticleView />} /> :
                            <Route path="/knowledge-article/:slug" element={<KnowledgeViewLogout />} />
                        }
                    </>
                    : <>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/accepted-terms-conditions/:userid" element={<AccepetedTermsServices />} />
                        {loggedIn === true && permissionstest?.manage_knowledge_article === true ? <>
                            {permissionstest && permissionstest.manage_knowledge_article === true && <>
                                <Route path="/knowledge-article/:slug" element={<KnowledgeArticleView />} />
                                <Route path="/knowledge/bookmark" element={<KnowledgeArticleBookmark />} />
                                <Route path="/knowledge" element={<KnowledgeArticle />} />
                            </>}
                        </>
                            :
                            <Route path="/knowledge-article/:slug" element={<KnowledgeViewLogout />} />
                        }
                        {permissionstest && permissionstest.manage_employee_reviews === true && <>
                            <Route path="/employee-reviews" element={<RecruiterReviews />} />
                            <Route path="/employee-reviews/view/:id" element={<ViewRecruiterReview />} />
                        </>}
                        {permissionstest && permissionstest.manage_org_chart === true &&
                            <Route path="/org-chart" element={<OrgChart />} />
                        }
                        <Route path="/timesheet/submit-timesheet" element={<SubmitTimesheet />} />
                        <Route path="/timesheet/activity-timesheet" element={<ActivityTimesheet />} />
                        <Route path="/timesheet/employee" element={<ManageTimesheet />} />
                        <Route path="/timesheet/project" element={<ManageProjectTimesheet />} />
                        <Route path="/timesheet/project-review" element={<ApproveProjectTimesheet />} />
                        <Route path="/timesheet/employee-review" element={<ApproveTimesheet />} />
                        <Route path="/timesheet/admin-review" element={<TimesheetAdmin />} />
                        <Route path="/timesheet/project-assign" element={<TimesheetProject />} />
                        <Route path="/timesheet/notes-timesheet" element={<NotesTimesheet />} />
                        <Route path="/timesheet/files-timesheet" element={<FilesTimesheet />} />

                        <Route path="/reports" element={<Reports />} />
                        <Route path="/reports/jobseeker" element={<ReportsJobseeker />} />
                        <Route path="/reports/knowledge" element={<ReportsKba />} />
                        <Route path="/my-dashboard" element={<MyDashboard />} />

                        {role && role === "job_seeker" ?
                            <Route path="/profile/jobseeker" element={<SeekerProfile />} />
                            :
                            <Route path="/profile/member" element={<MemberProfile />} />
                        }
                        {role && role === "job_seeker" && permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && <>
                            <Route path="/job-board/my-job" element={<MyJobs />} />
                            <Route path="/job-board/job-details/:slug" element={<ViewJobDetails />} />
                            <Route path="/job-board/job-list" element={<JobList />} />
                        </>}
                        <Route path="/notification" element={<Notifications />} />
                        {permissionstest && permissionstest.manage_catalog === true && <>
                            <Route path="/catalogs/global-services" element={<GlobalService />} />
                            <Route path="/catalogs/consulting-services" element={<ConsultingServices />} />
                            <Route path="/catalogs/interviews-booking/:id" element={<InterviewsBooking />} />
                            <Route path="/catalogs/interviews-opportunity" element={<Opportunity />} />
                            <Route path="/catalogs/interviews-slot/:id/:opid" element={<InterviewsSlot />} />
                            <Route path="/catalogs/create-opportunity" element={<CreateOpportunity />} />
                            <Route path="/catalogs/create-interview/:id" element={<CreateInterview />} />
                            <Route path="/catalogs/jobseeker-services" element={<Catalogs />} />
                            {role && role === "job_seeker" &&
                                <Route path="/catalogs/editrequest" element={<EditRequest />} />
                            }
                        </>}
                        {permissionstest && permissionstest.manage_community_members === true && <>
                            <Route path="/community-member" element={<CommunityMember />} />
                            {permissionstest && permissionstest.manage_community_creator === true &&
                                <Route path="/community-member/add" element={<CommunityMemberAdd />} />
                            }
                            {permissionstest && permissionstest.manage_community_editor === true &&
                                <Route path="/community-member/edit/:userid" element={<CommunityMemberEdit />} />
                            }
                            <Route path="/community-member/view/:userid" element={<ViewCommunityMember />} />
                        </>}

                        <Route path="/market-hold" element={<MarketHold />} />
                        <Route path="/certifications" element={<Certifications />} />
                        <Route path="/catalogs/report-tech-issue" element={<ReportTechIssue />} />

                        {permissionstest && permissionstest.manage_case_admin === true && <>
                            <Route path="/case/solution" element={<Solutions />} />
                            <Route path="/case/case-type" element={<CaseType />} />
                            <Route path="/case/case-sub-type" element={<CaseSubType />} />
                        </>}

                        {permissionstest && (permissionstest.manage_case_admin || permissionstest.manage_case_submitter) &&
                            <Route path="/catalogs/intake" element={<GeneralCase />} />
                        }
                        <Route path="/task/intake/:taskid/:caseid" element={<IntakeForm />} />
                        <Route path="/task/triage/:taskid/:caseid" element={<Triage />} />
                        <Route path="/task/dept-action/:taskid/:caseid" element={<InProgress />} />

                        <Route path="/task/interview/intake/:taskid/:caseid" element={<InterviewIntake />} />
                        <Route path="/task/interview/recruiter-form/:taskid/:caseid" element={<RecruiterForm />} />
                        {/* } */}
                        {permissionstest && (permissionstest.manage_case_admin || permissionstest.manage_case_approver) && <>
                            <Route path="/task/senior-partner-approval/:taskid/:caseid" element={<SeniorPartStep />} />
                            <Route path="/task/partner-voice-approval/:taskid/:caseid" element={<PartnerStep />} />
                        </>}

                        <Route path="/catalogs/report-btex" element={<ReportBtex />} />

                        {permissionstest && permissionstest.manage_my_requests === true ? <>
                            <Route path="/task/my-request" element={<MyRequest />} />
                        </> : ""}

                        {permissionstest && permissionstest.manage_my_tasks === true ? <>

                            <Route path="/task/view-tech-issue/:userid/:taskid" element={<TechReportView />} />
                            <Route path="/anonymous-feedback" element={<Feedback />} />
                            <Route path="/task/my-task" element={<MyTask />} />
                            <Route path="/task/group-task" element={<GroupTask />} />
                            <Route path="/task/my-cases" element={<MyCases />} />
                            <Route path="/task/my-raised-cases" element={<MyRaisedCases />} />
                            <Route path="/task/raised-cases" element={<RaisedCasesSeekers />} />
                            <Route path="/task/my-group-cases" element={<MyGroupCases />} />
                            <Route path="/task/all-task/:optionalParam?" element={<AllTaskList />} />

                            <Route path="/task/i94-validation/:userid/:taskid" element={<I94Validation onClose={handleClose} />} />
                            <Route path="/task/verify-member-details/:userid/:taskid" element={<VerifyMember />} />
                            <Route path="/task/member-confirmation/:userid/:taskid" element={<MemberConfirmation />} />
                            <Route path="/task/referral-investigation/:userid/:taskid" element={<ReferralInvestigation />} />
                            <Route path="/task/engagement-overview/:userid/:taskid" element={<EngagementOverview />} />
                            <Route path="/task/jobseeker-classification/:userid/:taskid" element={<JobseekersClassification />} />
                            <Route path="/task/setup-servicenow-interview/:userid/:taskid" element={<SetupInterview />} />
                            <Route path="/task/servicenow-interview-evaluation/:userid/:taskid" element={<InterviewEvaluation />} />
                            <Route path="/task/past-payment-health-approval/:userid/:taskid" element={<PastPaymentHealth />} />
                            <Route path="/task/application-final-review/:userid/:taskid" element={<ApplicationFinalReview />} />
                            <Route path="/task/placement-agreement/:userid/:taskid" element={<PlacementAgreements />} />
                            <Route path="/task/communication-eligibility/:userid/:taskid" element={<CommunicationEligibility />} />
                            <Route path="/task/admission-fees-payment/:userid/:taskid" element={<AdmissionFeesPayment />} />

                            <Route path="/task/immigration-history" element={<ImmigrationHistory />} />
                            <Route path="/task/immigration-review" element={<ImmigrationReview />} />
                            <Route path="/task/job-post-linkedin" element={<JobPostLinkedin />} />
                            <Route path="/task/apply-job" element={<ApplyforJob />} />
                            <Route path="/task/my_request_profile/:userid/:taskid" element={<ProfileCorrection />} />
                        </> : ""}
                        {role && (role === "admin" || role === "sub_admin") && (
                            <>
                                {permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && <>
                                    <Route path="/job-board" element={<JobBoard />} />
                                    <Route path="/job-board/view-job/:slug" element={<ViewJobBoard />} />
                                </>}
                                {role && role !== "job_seeker" && permissionstest?.recruiter_admin === true && <>
                                    <Route path="/recruiter/it-recruiter" element={<ItRecruiterMain />} />
                                    <Route path="/recruiter/it/create" element={<ItRecruiterCreate />} />
                                    <Route path="/recruiter/it/edit/:id" element={<ItRecruiterEdit />} />
                                    <Route path="/recruiter/it/view/:id" element={<ItRecruiterShow />} />

                                    <Route path="/recruiter/vendor-company" element={<VendorCompanyMain />} />
                                    <Route path="/recruiter/vendor-company/create" element={<VendorCompanyCreate />} />
                                    <Route path="/recruiter/vendor-company/view/:id" element={<VendorCompanyShow />} />
                                    <Route path="/recruiter/vendor-company/edit/:id" element={<VendorCompanyEdit />} />
                                </>}
                                {permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && permissionstest.manage_job_post_creator === true && <>
                                    <Route path="/job-board/create-job" element={<AddJobBoard />} />
                                    <Route path="/job-board/bulk-upload" element={<JobBulkUpload />} />
                                </>}
                                {permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && permissionstest.manage_job_post_editor === true && <>
                                    <Route path="/job-board/edit-job/:slug" element={<EditJobs />} />
                                </>}
                                {permissionstest && permissionstest.manage_group_reader === true &&
                                    <Route path="/user/group" element={<UserGroup />} />
                                }
                                {permissionstest && permissionstest.manage_group_creator === true &&
                                    <Route path="/user/group-add" element={<UserGroupAdd />} />
                                }
                                {permissionstest && permissionstest.manage_group_writer === true &&
                                    <Route path="/user/group-edit/:id" element={<UserGroupEdit />} />
                                }
                                {permissionstest && permissionstest.manage_subadmin_writer === true && <>
                                    <Route path="/user/permissions" element={<UserRoles />} />
                                    <Route path="/user/permissions-details/:id" element={<UserRoleDetail />} />
                                    <Route path="/user/audit-history" element={<UserAuditHistory />} />
                                </>}
                                {permissionstest && permissionstest.manage_subadmin_reader === true &&
                                    <Route path="/user/member" element={<UserMember />} />
                                }
                                {permissionstest && permissionstest.manage_subadmin_writer === true && <>
                                    <Route path="/user/member-add" element={<UserMemberAdd />} />
                                    <Route path="/user/member-edit/:id" element={<UserMemberEdit />} />
                                </>
                                }
                                {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                    <Route path="/user/jobseekers" element={<UserJobSeekers />} />
                                }
                                {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                    <Route path="/user/jobseeker-edit/:id" element={<JobseekerFormEdit />} />
                                }
                                <Route path="/user/jobseeker-details/:id" element={<JobseekerFormDetails />} />
                                <Route path="/user/jobseeker-profile/:id" element={<JobseekerProfile />} />
                                {permissionstest && permissionstest.manage_knowledge_article === true ? <>
                                    {permissionstest.manage_kba_admin === true || permissionstest.manage_kba_creator === true ? <>
                                        <Route path="/knowledge/draft" element={<Draft />} />
                                        <Route path="/knowledge/attachments/:id" element={<Attachments />} />
                                        <Route path="/knowledge/under-approval" element={<UnderApproval />} />
                                        <Route path="/knowledge/published" element={<Published />} />
                                        <Route path="/knowledge/retired" element={<Retired />} />
                                        <Route path="/knowledge/under-approval/show/:id" element={<UnderApprovalShow />} />
                                        <Route path="/knowledge/history/:id" element={<UnderApprovalHistory />} />
                                        <Route path="/knowledge/versions/:id" element={<VersionsArticle />} />
                                        <Route path="/knowledge/discussions/:id" element={<Discursion />} />
                                        <Route path="/knowledge/assignments/:id" element={<KbAssignments />} />
                                        <Route path="/knowledge/add-draft" element={<DraftAdd />} />
                                        <Route path="/knowledge/edit-article/:id" element={<DraftEdit />} />
                                        <Route path="/knowledge/preview/:id" element={<KnowledgeArticlePreview />} />
                                    </> : ""}
                                    {role && role === "admin" && <>
                                        <Route path="/knowledge/root" element={<KnowledgeBase />} />
                                        <Route path="/knowledge/category" element={<KnowledgeCategory />} />
                                        <Route path="/knowledge/sub-category" element={<KnowledgeSubCategory />} />
                                        <Route path="/settings/general" element={<SettingsGeneral />} />
                                        <Route path="/settings/onboarding" element={<SettingsOnboard />} />
                                        <Route path="/settings/smtp" element={<SettingsSmtp />} />
                                        <Route path="/settings/s3-file-system" element={<SettingsS3file />} />
                                        <Route path="/settings/payment" element={<SettingsPayment />} />
                                        <Route path="/settings/social-links" element={<SettingsSocialLink />} />
                                        <Route path="/settings/update-terms" element={<SettingsTerms />} />
                                    </>}
                                </> : ""}
                            </>
                        )}
                    </>}
                {/* Redirect to login if route is not found */}
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </>
    );

    return (
        <div className='container-fluid px-0'>
            {!hideHeader && (
                <>
                    <Allheader />
                </>
            )}
            {loggedIn &&
                <SessionActive />
            }
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Homepage />} />
                <Route path="/loginselect" element={<Loginselect />} />
                <Route path="/forgotpassword" element={<ForgetPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/termsandcondition" element={<TermsandCondition />} />
                <Route path="/termsofservice" element={<TermsofServices />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/registration" element={<RegisterIds />} />
                <Route path="/registration/personal-questions" element={<RegisterDetail1 formData={formData} onFormDataChange={handleFormDataChange} />} />
                <Route path="/registration/immigration-questions" element={<RegisterDetail2 formData={formData} onFormDataChange={handleFormDataChange} />} />
                <Route path="/registration/emergency-contact" element={<RegisterDetail3 formData={formData} onFormDataChange={handleFormDataChange} />} />
                <Route path="/registration/referral-information" element={<RegisterDetail4 formData={formData} onFormDataChange={handleFormDataChange} />} />
                {/* Private Routes */}
                <Route path="/*" element={<AuthenticatedRoutes />} />
            </Routes>
        </div>
    );
};

export default AppRoutes;
